import { createTheme } from '@mui/material/styles';

/**
 * Tema do painel operacional. Os tokens semânticos vêm de @caremesh/design-tokens;
 * aqui só traduzimos para o MUI, sem redefinir a paleta de marca.
 */
export const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#4A3656' },
    secondary: { main: '#8DAA98' },
    warning: { main: '#C08A3E' },
    background: { default: '#FBF7F2', paper: '#FFFFFF' },
  },
  typography: {
    fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, sans-serif',
    h1: { fontSize: '1.5rem', fontWeight: 600 },
    h2: { fontSize: '1.25rem', fontWeight: 600 },
  },
  shape: { borderRadius: 12 },
  spacing: 8,
});
